import { Card } from '@/components/ui/card';
import { ShieldCheck, Check } from 'lucide-react';
import { useTranslation } from '@/i18n/i18n';

export const ComplianceBox = () => {
  const { t } = useTranslation();

  return (
    <section className="py-12 px-5 sm:px-6 md:px-8 md:py-16">
      <div className="max-w-4xl mx-auto">
        <Card className="overflow-hidden p-5 bg-muted/30 border-2 border-border sm:p-8">
          <div className="flex flex-col items-start gap-4 sm:flex-row">
            <div className="flex-shrink-0 text-foreground">
              <ShieldCheck className="size-8" />
            </div>
            <div className="min-w-0 space-y-4">
              <h3 className="text-xl font-semibold leading-tight text-foreground sm:text-2xl">
                {t('compliance.heading')}
              </h3>
              <ul className="space-y-3 text-muted-foreground leading-relaxed">
                {[t('compliance.item1'), t('compliance.item2'), t('compliance.item3')].map(
                  (item) => (
                    <li key={item} className="flex min-w-0 items-start gap-2.5 sm:gap-3">
                      <Check className="size-5 text-success flex-shrink-0 mt-0.5" />
                      <span className="min-w-0 break-words">{item}</span>
                    </li>
                  )
                )}
              </ul>
              <p className="text-xs leading-relaxed text-muted-foreground">
                {t('compliance.taxAdvisorDisclaimer')}
              </p>
            </div>
          </div>
        </Card>
      </div>
    </section>
  );
};
